import { Button } from "@mui/material";
import { useRouter } from "next/router";
import { useCallback } from "react";

import { Routes } from "../../Routes";

export const SwitchOrgButton: React.FC<React.PropsWithChildren> = ({ children }) => {
    const router = useRouter();
    const redirectToOrgsPage = useCallback(() => router.push(Routes.Orgs()), [router]);

    return (
        <Button onClick={redirectToOrgsPage} variant="outlined">
            {children ?? "Switch Org"}
        </Button>
    );
};
